module.exports = __webpack_public_path__ + "img/biaoqian_rukou.9e96a1c1.png";